import type { PuzzleMode } from '../../engine/types';
import { TangleBoard } from './Board';
import {
  TANGLE_DIFFICULTIES,
  deserialize,
  generate,
  handleKey,
  hint,
  moveFeedback,
  reduce,
  score,
  status,
  summarize,
  validateMove,
  type TangleConfig,
  type TangleMove,
  type TangleState,
} from './logic';

export const tangleMode: PuzzleMode<TangleState, TangleMove, TangleConfig> = {
  id: 'tangle',
  name: 'Tangle',
  tagline: 'Untangle the scrambled word',
  description:
    'Rearrange the scrambled letters to find the hidden word before the timer runs out. Any valid anagram counts.',
  accent: 'berry',
  glyph: 'tangle',
  ownTimer: true,
  howToPlay: [
    { title: 'Tap the letters', body: 'Tap (or type) the scrambled letters to spell a word.' },
    { title: 'Beat the timer', body: 'Solve before the ring empties. Tap a placed letter to take it back.' },
    { title: 'Any anagram works', body: 'There may be more than one valid answer — any of them counts.' },
  ],
  difficulties: TANGLE_DIFFICULTIES,
  defaultDifficultyId: 'standard',
  generate,
  reduce,
  status,
  validateMove,
  moveFeedback,
  handleKey,
  hint,
  score,
  summarize,
  serialize: (state) => state,
  deserialize,
  Board: TangleBoard,
};
